import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "subscription-preview__name" }
const _hoisted_2 = { class: "subscription-content" }
const _hoisted_3 = { class: "subscription-content__achievement" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "subscription-content__achievement-list"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 3,
  class: "subscription-content__achievement-list"
}
const _hoisted_8 = { class: "subscription-content__subscriptions" }
const _hoisted_9 = { class: "subscription-content__subscriptions__header" }
const _hoisted_10 = { class: "subscription-content__subscriptions__items" }
const _hoisted_11 = { class: "subscription-footer" }

import Button from "@/components/UI/Button/Button.vue";
import BillingService from "@/ts/Billing/Service/BillingService";
import DevModeService from "@/ts/User/Service/DevModeService";
import BlueCheckIcon from "@/components/UI/Icon/BlueCheckIcon.vue";
import {computed, nextTick, onMounted, ref, watch} from "vue";
import Subscription from "@/ts/User/Types/Subscription";
import SubscriptionRepository from "@/ts/User/Repository/SubscriptionRepository";
import FullPopup from "@/components/UI/Pupup/FullPopup.vue";
import SubscriptionItem from "@/components/User/Settings/Popup/SubscriptionItem.vue";
import SubscribedPopup from "@/components/User/Settings/Popup/SubscribedPopup.vue";
import SubscriptionService from "@/ts/User/Service/SubscriptionService";


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionPopup',
  props: {
    "show": {},
    "showModifiers": {},
  },
  emits: ["update:show"],
  setup(__props) {


const show = _useModel(__props, 'show')
const subscriptions = ref<Subscription[]>([]);
const selectedSubscriptionId = ref<string | null>(null);
const showSubscribedPopup = ref(false)
const onPayClick = async () => {
  if (hasClub.value) {
    const link = 'https://muradyangames.com/meta?utm_source=yuriclub&utm_medium=funnels&utm_campaign=clubverygood&utm_term=app.magicmoon&utm_content=23.05.25&utm_group=1_button';
    window.open(link, '_blank');
    return
  }
  if (selectedSubscriptionId.value === null) return
  if (!acceptOffer.value) {
    offerError.value = true
    return
  }
  const selectedSubscription = subscriptions.value.find(subscription => subscription.id === selectedSubscriptionId.value)
  const subscriptionService = SubscriptionService.getInstance()
  await subscriptionService.pay(selectedSubscription!)
}
const hasPro = ref(true)
const hasClub = ref(false)
const popup = ref<InstanceType<typeof FullPopup> | null>(null)
watch(() => show.value, async () => {
  if (show.value) {
    acceptOffer.value = false
    popup.value!.scrollToTop()
    if (hasPro.value && hasClub.value) {
      subscriptions.value = bothPrices
    } else if (!hasPro.value && hasClub.value) {
      subscriptions.value = onlyClubPrices
    } else {
      subscriptions.value = await SubscriptionRepository.getAll()
    }
    const defaultSubscription = subscriptions.value.find(subscription => subscription.isDefault)
    selectedSubscriptionId.value = defaultSubscription?.id || subscriptions.value[0].id
  }
})
const bothPrices: Subscription[] = [
  {
    name: 'Подписка на 1 месяц',
    price: 8900,
    discount: 0,
    id: '1_month',
    isDefault: false,
    durationInMonths: 1,
  }
]
const onlyClubPrices: Subscription[] = [
  {
    name: 'Подписка на 1 месяц',
    price: 7310,
    discount: 0,
    id: '1_month',
    isDefault: false,
    durationInMonths: 1,
  },
]
const appListItems = [
  'Новые медитации уровня PRO',
  '10 гениальных дневников для саморевлексии, работы с целями, желаниями и другими аспектами жизни',
  'Полная версия книги «Игра Атлантов. Алхимия мечты»',
  '4 колоды метафорических карт, которые помогут найти ответы на все вопросы',
  'Расширенный функционал постановки целей',]
const clubListItems = [
  'Годовая программа по формированию навыка позитивного мышления, спокойного ума и простых действий от Юрия Мурадяна',
  'Ежемесячная практика с куратором',
  'Доступ к базе с записью всех прошедших вебинаров и подкастов',
  'Трехдневный практикум по целеполаганию',
  'Чат Клуба в Telegram с единомышленниками',
  'Открытые трансформационные игры',]
const acceptOffer = ref(false)
const offerError = ref(false)

const onClickOffer = () => {
  acceptOffer.value = !acceptOffer.value
  offerError.value = false
}
onMounted(() => {
  const subscriptionService = SubscriptionService.getInstance()
  subscriptionService.addEventListener('subscribed', () => {
    show.value = false
    showSubscribedPopup.value = true
  })
  subscriptionService.addEventListener('show', (pro: boolean, club: boolean) => {
    hasPro.value = pro
    hasClub.value = club
    show.value = true
  })
  subscriptionService.addEventListener('hide', () => {
    show.value = false
  })
  subscriptionService.init()
})
const title = computed(() => {
  if (!hasPro.value && hasClub.value) {
    return 'Доступ к Клубу \n' +
        '«Ооочень хорошо»'
  } else {
    return 'Подписка PRO'
  }
})

const previewClass = computed(() => {
  if (hasPro.value && hasClub.value) {
    return 'pro-club'
  } else if (hasPro.value) {
    return 'pro'
  } else {
    return 'club'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FullPopup, {
      show: show.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      theme: "dark",
      closed: "",
      padding: false,
      ref_key: "popup",
      ref: popup
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["subscription-preview", [previewClass.value]])
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "subscription-preview__about" }, "О подписке", -1)),
          _createElementVNode("div", _hoisted_1, _toDisplayString(title.value), 1)
        ], 2),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (hasPro.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "С подпиской PRO вы получаете полный доступ к уникальным инструментам для личностного роста и гармонизации жизни: "))
              : _createCommentVNode("", true),
            (hasPro.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(appListItems, (item) => {
                    return _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _createVNode(BlueCheckIcon, { size: 24 })
                      ]),
                      _createElementVNode("div", null, _toDisplayString(item), 1)
                    ])
                  }), 64))
                ]))
              : _createCommentVNode("", true),
            (hasClub.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Доступ к Клубу «Ооочень хорошо» Юрия Мурадяна"))
              : _createCommentVNode("", true),
            (hasClub.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(clubListItems, (item) => {
                    return _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _createVNode(BlueCheckIcon, { size: 24 })
                      ]),
                      _createElementVNode("div", null, _toDisplayString(item), 1)
                    ])
                  }), 64))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(subscriptions.value.length > 1 ? 'Выберите варианты подписки' : 'Оплатите подписку') + ": ", 1),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subscriptions.value, (subscription) => {
                return (_openBlock(), _createBlock(SubscriptionItem, _mergeProps({ ref_for: true }, subscription, {
                  modelValue: selectedSubscriptionId.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSubscriptionId).value = $event))
                }), null, 16, ["modelValue"]))
              }), 256))
            ]),
            _createElementVNode("div", {
              class: "subscription-content__offer",
              onClick: onClickOffer
            }, [
              _createVNode(BlueCheckIcon, {
                size: 20,
                active: acceptOffer.value,
                error: offerError.value
              }, null, 8, ["active", "error"]),
              _cache[4] || (_cache[4] = _createElementVNode("div", null, [
                _createTextVNode("Я соглашаюсь с договором "),
                _createElementVNode("a", {
                  href: "/files/app_offer.pdf",
                  target: "_blank"
                }, "оферты")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(Button, {
            text: "Продолжить",
            active: "",
            class: "subscription-footer__button",
            onClick: onPayClick
          })
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "subscription-footer__additional" }, [
          _createElementVNode("div", { class: "subscription-footer__additional__cancel" }, "Отменить можно в любое время"),
          _createElementVNode("div", { class: "subscription-footer__additional__help" }, "Нужна помощь?")
        ], -1))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(SubscribedPopup, {
      show: showSubscribedPopup.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showSubscribedPopup).value = $event))
    }, null, 8, ["show"])
  ], 64))
}
}

})